import React from 'react';
import styled from 'styled-components';
import type { SelectFieldProps } from '@oneaudi/unified-web-components';
import { SelectField } from '@oneaudi/unified-web-components';

import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import { trackRadiusChangeAction } from '../../../utils/trackingUtils';
import trackingContext from '../../../contexts/tracking-context';
import historyContext from '../../../contexts/history-context';

const useHandleSetSearchRadius = () => {
  const { trackingService: tService } = trackingContext.useTrackingState();
  const dispatch = mapContext.useMapDispatch();
  const { historyService } = historyContext.useHistoryState();

  return (item: React.ChangeEvent<HTMLSelectElement>) => {
    trackRadiusChangeAction(
      tService,
      `${item.target.value}km`,
      item.target.value,
      'SearchRadiusDropdown',
      window.location.href,
    );
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.append('radius', item.target.value);
    historyService?.history.replace(`?${searchParams}`);
    dispatch({ type: ActionTypes.setSearchRadius, payload: Number(item.target.value) });
  };
};

export const SearchRadiusDropdown = () => {
  const selectRef = React.useRef<HTMLSelectElement | null>(null);
  const { searchRadius, searchRadiusOptions, distanceUnit } = mapContext.useMapState();
  const onSetSearchRadius = useHandleSetSearchRadius();

  React.useEffect(() => {
    document
      .getElementById('search_radius_dropdown')
      ?.setAttribute('aria-label', 'Search radius dropdown');

    if (selectRef.current?.firstChild) {
      selectRef.current.removeChild(selectRef.current.firstChild);
    }
  }, []);

  return (
    <CustomSelect
      id="search_radius_dropdown"
      onChange={onSetSearchRadius}
      value={searchRadius.toString()}
      required
      spaceInlineStart="s"
      spaceStackEnd="m"
      inputRef={(inputRef: HTMLSelectElement | null) => (selectRef.current = inputRef)}
    >
      {searchRadiusOptions.map((optionValue) => (
        <option key={optionValue} value={optionValue.toString()}>
          {`${optionValue} ${distanceUnit}`}
        </option>
      ))}
    </CustomSelect>
  );
};

export const CustomSelect = styled((props) => <SelectField {...props} />)<SelectFieldProps>`
  width: auto !important;
  select {
    width: auto !important;
  }

  label {
    display: none;
  }
`;
